/**
 * Configurações de cores para materiais e qualidades
 */

import { resolveService, resolveQuality } from '../../../theme/resolvers';

// Materiais por nome (serviço)
export const materialColors: Record<string, string> = {
  'DTF TÊXTIL': resolveService('DTF TÊXTIL'),
  'DTF UV (VERNIZ)': resolveService('DTF UV (VERNIZ)'),
  'DTF UV (FOSCO)': resolveService('DTF UV (FOSCO)'),
  'SUBLIMAÇÃO (COM TACK)': resolveService('SUBLIMAÇÃO (COM TACK)'),
  'SUBLIMAÇÃO (SEM TACK)': resolveService('SUBLIMAÇÃO (SEM TACK)'),
  'ADESIVO UV (VERNIZ)': resolveService('ADESIVO UV (VERNIZ)'),
  'ADESIVO UV (FOSCO)': resolveService('ADESIVO UV (FOSCO)'),
  'NEUTRO': resolveService('NEUTRO')
};

// IDs de material → serviço
export const getMaterialColorById = (matId: number): string => {
  switch (matId) {
    case 1: // Brilho (UV)
    case 13:
      return resolveService('DTF UV (VERNIZ)');
    case 2: // Fosco (UV)
    case 14:
      return resolveService('DTF UV (FOSCO)');
    case 3: // Semi Brilho → aproximado ao fosco/verniz; manter fosco aqui
    case 15:
      return resolveService('DTF UV (FOSCO)');
    case 11: // Transparente (legado)
    case 17:
      return resolveService('NEUTRO');
    case 12: // Branco (legado)
    case 16:
      return resolveService('NEUTRO');
    default:
      return resolveService('NEUTRO');
  }
};

export const qualityColors = {
  'premium': resolveQuality('PREMIUM'),
  'classico': resolveQuality('CLASSICO'),
  'economico': resolveQuality('ECONOMICO')
};